import * as TabsPrimitive from '@radix-ui/react-tabs';

enum IconPosition {
	Before = 'before',
	After = 'after',
}

enum TabDirection {
	LTR = 'ltr',
	RTL = 'rtl',
}

interface TabItem {
	name: string;
	value?: string;
	page: React.ReactNode;
	icon?: React.ReactNode;
	disable?: boolean;
	hidden?: boolean;
	tooltip?: string;
	iconPosition?: IconPosition;
}

interface TabsProps extends TabsPrimitive.TabsProps {
	tabs: TabItem[];
	className?: string;
	defaultValue?: string;
	keyboardNavigation?: boolean;
	direction?: TabDirection;
	ariaLabels?: {
		tabList?: string;
		tab?: string;
		tabPanel?: string;
	};
	children?: React.ReactNode;
	beforeTabs?: React.ReactNode;
	margin?: string;
}
export { TabItem, TabsProps, IconPosition, TabDirection };
